import { lazy } from 'react';

export const AsyncPaymentPageContainer = lazy(() => import(
  /* webpackChunkName: 'payment_page' */
  './PaymentPageContainer'
));
